var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderNoBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "placeholder_no_bike",
    "data-name": "placeholder no bike",
    xmlns: "http://www.w3.org/2000/svg",
    width: 362,
    height: 175,
    viewBox: "0 0 362 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: red;\n            }\n\n            .cls-2 {\n            clip-path: url(#clip-path);\n            }\n\n            .cls-3 {\n            fill: url(#linear-gradient);\n            }\n\n            .cls-4 {\n            fill: #c7c7c7;\n            }\n\n            .cls-5 {\n            fill: #b1b1b1;\n            }\n\n            .cls-6 {\n            fill: #1a4988;\n            }\n\n            .cls-7 {\n            fill: #fff;\n            }\n\n            .cls-8 {\n            fill: #a4b0b5;\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    className: "cls-1",
    width: 362,
    height: 175,
    transform: "translate(502 267)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.07,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_37",
    "data-name": "Groupe de masques 37",
    className: "cls-2",
    transform: "translate(-502 -267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg_card",
    "data-name": "bg card",
    className: "cls-3",
    d: "M152,0h58A152,152,0,0,1,362,152v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A152,152,0,0,1,152,0Z",
    transform: "translate(502 289)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "park_sign",
    "data-name": "park sign",
    transform: "translate(-5.316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    className: "cls-4",
    width: 7,
    height: 124,
    transform: "translate(700.316 317)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    className: "cls-5",
    width: 7,
    height: 7,
    transform: "translate(700.316 317)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_219",
    "data-name": "Groupe 219",
    transform: "translate(676 267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    className: "cls-4",
    d: "M10.063-1h33.19A11.063,11.063,0,0,1,54.316,10.063v33.19A11.063,11.063,0,0,1,43.253,54.316H10.063A11.063,11.063,0,0,1-1,43.253V10.063A11.063,11.063,0,0,1,10.063-1Z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    className: "cls-6",
    width: 45,
    height: 45,
    rx: 6,
    transform: "translate(5.316 5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_195_-_Contour",
    "data-name": "Rectangle 195 - Contour",
    className: "cls-7",
    d: "M6.057.023A6.034,6.034,0,0,0,.023,6.057v33.19a6.034,6.034,0,0,0,6.034,6.034h33.19a6.034,6.034,0,0,0,6.034-6.034V6.057A6.034,6.034,0,0,0,39.247.023H6.057M6.057-4h33.19A10.069,10.069,0,0,1,49.3,6.057v33.19A10.069,10.069,0,0,1,39.247,49.3H6.057A10.069,10.069,0,0,1-4,39.247V6.057A10.069,10.069,0,0,1,6.057-4Z",
    transform: "translate(5.006 5.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_253",
    "data-name": "Trac\\xE9 253",
    className: "cls-7",
    d: "M7.261-12.034v-6.887h3.926a10.582,10.582,0,0,1,1.674.129,3.894,3.894,0,0,1,1.416.5,2.718,2.718,0,0,1,.982,1.046,3.676,3.676,0,0,1,.37,1.77,3.676,3.676,0,0,1-.37,1.77,2.718,2.718,0,0,1-.982,1.046,3.894,3.894,0,0,1-1.416.5,10.582,10.582,0,0,1-1.674.129ZM2.208-22.848V.131H7.261V-8.108h5.31a9.571,9.571,0,0,0,3.669-.628A6.864,6.864,0,0,0,18.7-10.393a6.346,6.346,0,0,0,1.384-2.366,8.739,8.739,0,0,0,.434-2.72,8.691,8.691,0,0,0-.434-2.736A6.367,6.367,0,0,0,18.7-20.563,6.864,6.864,0,0,0,16.24-22.22a9.571,9.571,0,0,0-3.669-.628Z",
    transform: "translate(18.116 39.016)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "fastener",
    className: "cls-8",
    d: "M16117.729-276.525v-10.261a4.1,4.1,0,0,0-4.1-4.095h-23.549a4.094,4.094,0,0,0-4.095,4.095v10.261h-5.119v-10.261a9.222,9.222,0,0,1,9.214-9.213h23.549a9.224,9.224,0,0,1,9.214,9.213v10.261Zm-47.73,0v-10a4,4,0,0,0-4-4h-23a4,4,0,0,0-4,4v10h-5v-10a9.012,9.012,0,0,1,9-9h23a9.012,9.012,0,0,1,9,9v10Z",
    transform: "translate(-15398.406 717.525)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderNoBike);
export default __webpack_public_path__ + "static/media/placeholderNoBike.851f0b5809a527d07f89d3f5d7fe213d.svg";
export { ForwardRef as ReactComponent };